<template>
  <div>
    <v-dialog v-model="listPayer" persistent max-width="1200px">
      <template v-slot:activator="{ on }">
        <v-btn outline color="indigo" v-on="on" :loading="isLoading">&nbsp;Gerenciar favoritos&nbsp;</v-btn>
      </template>
      <v-flex v-if="isLoading">
        <v-text-field color="primary" loading disabled></v-text-field>
      </v-flex>
      <v-card v-resize="onResize" column style="padding-top:56px">
        <v-card-title>Favoritos</v-card-title>
        <v-divider></v-divider>
        <v-data-table
          v-if="listPayer"
          :headers="headers"
          :items="payersList"
          :loading="isLoading"
          :return-object="true"
          :hide-headers="isMobile"
          :class="{mobile: isMobile}"
        >
          <template v-slot:items="props">
            <tr v-if="!isMobile">
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">
                    <v-btn class="mx-2" fab dark small color="primary"
                      :loading="isLoading"
                      @click="updatePayer(props.item)"
                    >
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-left">
                    <v-btn class="mx-2" fab dark small color="error"
                      :loading="isLoading"
                      @click="deletePayer(props.item.id)"
                    >
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr v-else>
                  <td>
                    <ul class="flex-content">
                      <li class="flex-item" data-label="ID">{{ props.item.name }}</li>
                      <li class="flex-item" data-label="Criada em">{{  props.item.email }}</li>
                      <li class="flex-item" data-label="Nome">{{ props.item.name }}</li>
                      <li class="flex-item" data-label="Tipo de conta">
                        <v-btn class="mx-2" fab dark small color="primary"
                          :loading="isLoading"
                          @click="updatePayer(props.item)"
                        >
                          <v-icon dark>edit</v-icon>
                        </v-btn>
                      </li>
                      <li class="flex-item" data-label="CPF" style="margin-bottom:30px;">
                      <v-btn class="mx-2" fab dark small color="error"
                        :loading="isLoading"
                        @click="deletePayer(props.item.id)"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      </li>
                    </ul>
                  </td>
                </tr>
          </template>
        </v-data-table>
        <v-card-actions >
            <v-btn class="white--text" color="blue darken-1" text @click="listPayer = false">Fechar</v-btn>
            <v-btn class="white--text" color="blue darken-1" text @click="newPayer = true">Novo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newPayer" persistent max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">Cadastrar favorito</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="payer.name" label="Nome*" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="payer.email" label="E-mail*" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete
                  v-model="payer.document_type"
                  :items="['CPF', 'CNPJ']"
                  label="Tipo de documento*"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="payer.document" label="Documento*" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="payer.address_street" label="Rua*" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="payer.address_number" label="Número*" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="payer.address_neighborhood" label="Bairro*" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="payer.address_city" label="Cidade*" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="payer.address_state" label="Estado*" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="payer.address_code" label="CEP*" required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*campos requeridos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="newPayer = false">Fechar</v-btn>
          <v-btn color="blue darken-1" v-if="newBtPayer" text @click="sendNewPayer()">Savar</v-btn>
          <v-btn color="blue darken-1" v-if="updateBtPayer" text @click="sendUpdatePayer()">Atualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import { EventBus } from "@/services/event-bus";

  export default {
    name: 'NewPayerForm',
    computed: {
    ...mapGetters({
        payersList: "account/accountPayers",
        isLoading: 'account/isLoad'
      })
    },
    data () {
      return {
        newPayer: false,
        listPayer: false,
        newBtPayer: true,
        updateBtPayer: false,
        isMobile: false,
        headers: [
          { text: 'Nome', value: 'name' },
          { text: 'E-mail', value: 'email' },
          { text: 'Editar', value: 'edit' },
          { text: 'Deletar', value: 'delete' },
        ],
        payer: {
          id: '',
          name: '',
          email: '',
          document_type: '',
          document: '',
          address_street: '',
          address_number: '',
          address_neighborhood: '',
          address_city: '',
          address_state: '',
          address_code: '',
        },
        params: [],
        loadingButton: false,
      }
    },
    methods: {
      deletePayer (id) {
        this.params = {
          id: id
        }
        const response = this.$store.dispatch(
          "account/deleteAccountPayers",
          this.params
        );
      },
      getParams() {
        this.params = {
          id: this.payer.id,
          name: this.payer.name,
          email: this.payer.email,
          document_type: this.payer.document_type,
          document: this.payer.document,
          address_street: this.payer.address_street,
          address_number: this.payer.address_number,
          address_neighborhood: this.payer.address_neighborhood,
          address_city: this.payer.address_city,
          address_state: this.payer.address_state,
          address_code: this.payer.address_code,
        }
      },
      sendNewPayer() {
        this.getParams();
        const response = this.$store.dispatch(
          "account/newAccountPayers",
          this.params
        );
        this.newPayer = false;
      },
      updatePayer(uPayer) {
        this.payer.id = uPayer.id;
        this.payer.name = uPayer.name;
        this.payer.email = uPayer.email;
        this.payer.document_type = uPayer.document_type;
        this.payer.document = uPayer.document;
        this.payer.address_street = uPayer.address_street;
        this.payer.address_number = uPayer.address_number;
        this.payer.address_neighborhood = uPayer.address_neighborhood;
        this.payer.address_city = uPayer.address_city;
        this.payer.address_state = uPayer.address_state;
        this.payer.address_code = uPayer.address_code;
        this.newBtPayer = false;
        this.updateBtPayer = true;
        this.newPayer = true;
      },
      sendUpdatePayer() {
        this.getParams();
        const response = this.$store.dispatch(
          "account/updateAccountPayers",
          this.params
        );
        this.newPayer = false;
      },
       onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
    }
  }
</script>
<style>
.mobile {
      color: #333;
    }

    @media screen and (max-width: 768px) {
      .mobile table.v-table tr {
        max-width: 100%;
        position: relative;
        display: block;
      }

      .mobile table.v-table tr:nth-child(odd) {
        border-left: 6px solid #b2b2b8;
      }

      .mobile table.v-table tr:nth-child(even) {
        border-left: 6px solid #636366;
      }

      .mobile table.v-table tr td {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #f5f5f5;
        height: auto;
        padding: 10px;
      }

      .mobile table.v-table tr td ul li:before {
        content: attr(data-label);
        padding-right: .5em;
        text-align: left;
        display: block;
        color: #999;

      }
      .v-datatable__actions__select
      {
        width: 50%;
        margin: 0px;
        justify-content: flex-start;
      }
      .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
        background: transparent;
      }

    }
    .flex-content {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .flex-item {
      padding: 5px;
      width: 50%;
      height: 40px;
      font-weight: bold;
      margin-top: 10px;
    }
</style>

